// Runtime-derived build identity — the bundle hash can't be known at build time,
// but the running page knows exactly which main.<hash>.js it loaded.
export const bundleHash = () => {
  const src = Array.from(document.scripts, (s) => s.src).find((s) => /\/static\/js\/main\.[a-z0-9]+\.js/.test(s));
  const m = src && src.match(/main\.([a-z0-9]+)\.js/);
  return m ? m[1] : "dev";
};

export const fetchSwVersion = async () => {
  try {
    const txt = await (await fetch("/sw.js", { cache: "no-store" })).text();
    const m = txt.match(/hakina-shell-v(\d+)/);
    return m ? `v${m[1]}` : "not found";
  } catch {
    return "unavailable";
  }
};
